module.exports = __webpack_public_path__ + "img/Jornadas_Tecnicas_flyer.02082788.jpg";